(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["BXYZ-CL-Flipbook"] && !Shopify.designMode) return;
  try {
    
  // bxyz--notis-- 2025-11-03: CSS animations handle the slideshow automatically
  console.log('Flipbook using CSS animations - no JavaScript needed');

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-article-modular"] && !Shopify.designMode) return;
  try {
    
  // bxyz--notis-- 2025-10-30: artikel galleri navigation
  class ArticleGallery {
    constructor(section) {
      this.section = section;
      this.blockId = section.dataset.galleryBlock;
      this.slides = section.querySelectorAll('.article-gallery__slide');
      this.prevBtn = section.querySelector(`[data-gallery="${this.blockId}"].gallery-nav-btn--prev`);
      this.nextBtn = section.querySelector(`[data-gallery="${this.blockId}"].gallery-nav-btn--next`);
      this.counter = section.querySelector('.gallery-counter__current');
      this.currentIndex = 0;
      
      if (this.slides.length > 1) {
        this.init();
      }
    }

    init() {
      if (this.prevBtn) this.prevBtn.addEventListener('click', () => this.prev());
      if (this.nextBtn) this.nextBtn.addEventListener('click', () => this.next());
    }

    goToSlide(index) {
      this.slides[this.currentIndex].classList.remove('active');
      this.currentIndex = index;
      this.slides[this.currentIndex].classList.add('active');
      
      if (this.counter) {
        this.counter.textContent = this.currentIndex + 1;
      }
    }

    next() {
      const nextIndex = (this.currentIndex + 1) % this.slides.length;
      this.goToSlide(nextIndex);
    }

    prev() {
      const prevIndex = (this.currentIndex - 1 + this.slides.length) % this.slides.length;
      this.goToSlide(prevIndex);
    }
  }

  // init alla artikel gallerier
  const articleGalleries = document.querySelectorAll('[data-gallery-block]');
  articleGalleries.forEach(gallery => new ArticleGallery(gallery));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-article-rows"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-article-row]').forEach(function (row) {
      var toggle = row.querySelector('[data-article-toggle]');
      var content = row.querySelector('[data-article-content]');
      if (!toggle || !content) return;

      toggle.addEventListener('click', function () {
        var isOpen = row.classList.contains('is-open');

        if (isOpen) {
          // close
          gsap.to(content, {
            height: 0,
            duration: 0.4,
            ease: 'power2.inOut',
            onComplete: function () {
              row.classList.remove('is-open');
              toggle.setAttribute('aria-expanded', 'false');
            }
          });
        } else {
          // open
          row.classList.add('is-open');
          toggle.setAttribute('aria-expanded', 'true');
          var inner = content.querySelector('.cl-article-row__inner');
          var targetHeight = inner.offsetHeight;
          gsap.fromTo(content,
            { height: 0 },
            { height: targetHeight, duration: 0.4, ease: 'power2.inOut' }
          );
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-cart-drawer"]) return;
  try {
    
  // bxyz--notis-- 2025-11-02: cart drawer logik
  class CLCartDrawer {
    constructor() {
      this.drawer = document.querySelector('[data-cart-drawer]');
      this.overlay = document.querySelector('[data-cart-overlay]');
      this.closeBtn = document.querySelector('[data-cart-close]');
      this.openBtns = document.querySelectorAll('[data-cart-open]');
      
      // markera som initialiserad
      if (this.drawer) {
        this.drawer.classList.add('cl-drawer-initialized');
      }
      
      this.init();
    }

    init() {
      console.log('Cart drawer init, found', this.openBtns.length, 'open buttons');
      
      // öppna drawer
      this.openBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
          e.preventDefault();
          if (this.drawer.classList.contains('is-open')) {
            this.close();
          } else {
            this.open();
          }
        });
      });

      // stäng drawer
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', () => this.close());
      }

      if (this.overlay) {
        this.overlay.addEventListener('click', () => this.close());
      }

      // ESC key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.drawer.classList.contains('is-open')) {
          this.close();
        }
      });

      // quantity changes
      document.querySelectorAll('[data-qty-change]').forEach(btn => {
        btn.addEventListener('click', (e) => this.updateQuantity(e));
      });

      // remove items
      document.querySelectorAll('[data-remove-item]').forEach(btn => {
        btn.addEventListener('click', (e) => this.removeItem(e));
      });
    }

    open() {
      console.log('Opening cart drawer...');
      this.drawer.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      console.log('Cart drawer opened, has is-open class:', this.drawer.classList.contains('is-open'));
    }

    close() {
      this.drawer.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    async updateQuantity(e) {
      const btn = e.target;
      const lineIndex = btn.dataset.qtyChange;
      const change = parseInt(btn.dataset.qty);
      const currentQty = parseInt(btn.parentElement.querySelector('.cl-cart-item__qty').textContent);
      const newQty = currentQty + change;

      if (newQty < 1) return;

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: lineIndex, quantity: newQty })
        });
        
        if (response.ok) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Cart update error:', error);
      }
    }

    async removeItem(e) {
      const btn = e.target;
      const key = btn.dataset.removeItem;

      try {
        const response = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: key, quantity: 0 })
        });
        
        if (response.ok) {
          window.location.reload();
        }
      } catch (error) {
        console.error('Cart remove error:', error);
      }
    }
  }

  // init cart drawer - med fördröjning för att säkerställa att header är laddad
  function initCartDrawer() {
    if (document.querySelector('[data-cart-drawer]')) {
      console.log('Initializing cart drawer...');
      new CLCartDrawer();
    } else {
      console.error('Cart drawer element not found!');
    }
  }

  // försök init direkt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    // dom redan laddad, kör direkt
    initCartDrawer();
  }

  // backup: försök igen efter kort fördröjning för att fånga sent laddade element
  setTimeout(function() {
    const existingDrawer = document.querySelector('[data-cart-drawer]');
    const openBtns = document.querySelectorAll('[data-cart-open]');
    if (existingDrawer && openBtns.length > 0 && !existingDrawer.classList.contains('cl-drawer-initialized')) {
      console.log('Re-initializing cart drawer with', openBtns.length, 'buttons found');
      existingDrawer.classList.add('cl-drawer-initialized');
      new CLCartDrawer();
    }
  }, 500);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-cookie-consent"] && !Shopify.designMode) return;
  try {
    
  function checkCookieConsent() {
    const consent = localStorage.getItem('cookieConsent');
    if (!consent) {
      document.getElementById('cookieConsent').style.display = 'block';
    }
  }

  function acceptCookies() {
    localStorage.setItem('cookieConsent', 'accepted');
    document.getElementById('cookieConsent').style.display = 'none';
  }

  function declineCookies() {
    localStorage.setItem('cookieConsent', 'declined');
    document.getElementById('cookieConsent').style.display = 'none';
  }

  function manageCookies() {
    // bxyz--notis-- 2025-10-20: öppna cookie inställningar
    alert('Cookie preferences would open here. You can customize this to show a modal with detailed cookie settings.');
  }

  document.addEventListener('DOMContentLoaded', checkCookieConsent);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-gallery"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cl-gallery]').forEach(function (wrapper) {
      var track = wrapper.querySelector('[data-gallery-track]');
      var dots = wrapper.querySelectorAll('[data-gallery-dot]');
      if (!track || !dots.length) {
        return;
      }

      var items = track.querySelectorAll('.cl-gallery__item');
      var currentIndex = 0;

      function updateDots() {
        dots.forEach(function (dot, index) {
          dot.classList.toggle('is-active', index === currentIndex);
        });
      }

      function scrollToIndex(index) {
        if (index < 0 || index >= items.length) {
          return;
        }
        var item = items[index];
        var trackRect = track.getBoundingClientRect();
        var itemRect = item.getBoundingClientRect();
        var scrollLeft = track.scrollLeft + (itemRect.left - trackRect.left) - (trackRect.width / 2) + (itemRect.width / 2);
        track.scrollTo({
          left: scrollLeft,
          behavior: 'smooth'
        });
        currentIndex = index;
        updateDots();
      }

      function getCurrentIndex() {
        var trackRect = track.getBoundingClientRect();
        var centerX = trackRect.left + trackRect.width / 2;
        var closestIndex = 0;
        var minDistance = Infinity;

        items.forEach(function (item, index) {
          var itemRect = item.getBoundingClientRect();
          var itemCenter = itemRect.left + itemRect.width / 2;
          var distance = Math.abs(centerX - itemCenter);
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = index;
          }
        });

        return closestIndex;
      }

      // Handle dot clicks
      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          scrollToIndex(index);
        });
      });

      // Update active dot on scroll
      track.addEventListener('scroll', function () {
        var newIndex = getCurrentIndex();
        if (newIndex !== currentIndex) {
          currentIndex = newIndex;
          updateDots();
        }
      }, { passive: true });

      // Initialize
      updateDots();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-header"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // logo shrink vid scroll
    const header = document.querySelector('.site-header');
    const logoFull = document.querySelector('.header-logo-full');
    const logoPill = document.querySelector('.header-logo-pill');
    const scrollThreshold = 80;

    function handleScroll() {
      const currentScroll = window.pageYOffset || document.documentElement.scrollTop;
      if (currentScroll > scrollThreshold) {
        header.classList.add('scrolled');
      } else {
        header.classList.remove('scrolled');
      }
    }

    window.addEventListener('scroll', handleScroll, { passive: true });
    handleScroll();

    const menuToggle = document.querySelector('[data-menu-toggle]');
    const mobileMenu = document.querySelector('[data-mobile-menu]');
    const menuClose = document.querySelector('.mobile-menu__close');
    const navList = document.querySelector('[data-nav-list]');

    const isMobile = () => window.innerWidth <= 768;

    const animateMobileLinks = () => {
      if (!mobileMenu) return;
      const links = mobileMenu.querySelectorAll('.mobile-menu__link');
      if (!links || links.length === 0) return;
      if (window.gsap) {
        window.gsap.set(links, { opacity: 0, y: 8 });
        window.gsap.to(links, { opacity: 1, y: 0, duration: 0.35, ease: 'power1.out', stagger: 0.06 });
      } else {
        links.forEach((el, i) => {
          el.style.opacity = '0';
          el.style.transform = 'translateY(8px)';
          setTimeout(() => {
            el.style.transition = 'opacity .35s ease, transform .35s ease';
            el.style.opacity = '1';
            el.style.transform = 'translateY(0)';
          }, i * 60);
        });
      }
    };

    const resetMobileLinks = () => {
      if (!mobileMenu) return;
      const links = mobileMenu.querySelectorAll('.mobile-menu__link');
      links.forEach((el) => {
        el.style.opacity = '';
        el.style.transform = '';
        el.style.transition = '';
      });
    };

    if (menuToggle) {
      menuToggle.addEventListener('click', function(e) {
        e.preventDefault();
        if (isMobile()) {
          if (mobileMenu) {
            mobileMenu.setAttribute('data-open', 'true');
            document.body.style.overflow = 'hidden';
            animateMobileLinks();
          }
        } else {
          if (navList) {
            navList.classList.toggle('is-collapsed');
          }
        }
      });
    }

    if (menuClose && mobileMenu) {
      menuClose.addEventListener('click', function(e) {
        e.preventDefault();
        mobileMenu.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
        resetMobileLinks();
      });
    }

    if (mobileMenu) {
      mobileMenu.addEventListener('click', function(e) {
        if (e.target === mobileMenu) {
          mobileMenu.setAttribute('data-open', 'false');
          document.body.style.overflow = '';
          resetMobileLinks();
        }
      });
    }

    const handleResize = () => {
      if (!isMobile() && mobileMenu && mobileMenu.getAttribute('data-open') === 'true') {
        mobileMenu.setAttribute('data-open', 'false');
        document.body.style.overflow = '';
        resetMobileLinks();
      }
    };
    window.addEventListener('resize', handleResize);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["BXYZ-CL-intro-animation"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    const overlay = document.getElementById('intro-animation');
    if (!overlay) return;
    return; // bxyz: intro loader avstängd

    const frames = overlay.querySelectorAll('.intro-frame');
    const letters = overlay.querySelectorAll('.intro-letter');
    
    let currentFrame = 0;
    const totalFrames = frames.length;
    const frameDuration = 1000; // 1 second per frame
    const totalDuration = frameDuration * totalFrames;

    // Letters are now centered, no random positioning needed
    // Animate letters with subtle pulse
    letters.forEach((letter, index) => {
      gsap.to(letter, {
        scale: 1.1,
        duration: 0.5,
        ease: 'power2.inOut',
        repeat: -1,
        yoyo: true,
        delay: index * 0.2
      });
    });

    // Frame animation
    const frameInterval = setInterval(() => {
      frames[currentFrame].classList.remove('active');
      currentFrame = (currentFrame + 1) % totalFrames;
      frames[currentFrame].classList.add('active');
    }, frameDuration);

    // Fade out after animation
    setTimeout(() => {
      clearInterval(frameInterval);
      gsap.to(overlay, {
        opacity: 0,
        duration: 1,
        ease: 'power2.out',
        onComplete: () => overlay.style.display = 'none'
      });
    }, totalDuration);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
